<div class="row">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="marB16">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" name="suitabilitydialogbtn">
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16">{{ checkHrPanelInterviewObj.activityName }}</h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft">{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content class="clearfix" *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readflag }">
        <form #f1="ngForm" name="hrIntForm">
          <div *ngIf="this.testformValid(!f1.invalid)"></div>
          <mat-form-field class="custom-form-field">
            <mat-label>Result</mat-label>
            <mat-select name="coupledresults" required [(value)]="referenceId" [disabled]="loader">
              <mat-option *ngFor="let ref of referenceActivities" [value]="ref.id" class="custom-select-option">
                {{ ref.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="hractivity" class="field-container">
            <mat-form-field class="custom-form-field">
              <mat-label>Role</mat-label>
              <input
                type="text"
                required
                matInput
                [formControl]="roleControl"
                [matAutocomplete]="auto"
                [readonly]="onEdit"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  (click)="selectedJobSubLevel = role.jobSubLevel"
                  *ngFor="let role of filteredRoles | async"
                  [value]="role.roleCapDesc"
                  class="custom-select-option"
                >
                  {{ role.roleCapDesc }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="custom-form-field" id="jslDiv">
              <label id="labelJsl" class="label-font">Job Sub Level</label>
              <div>{{ selectedJobSubLevel }}</div>
            </div>
          </div>
          <mat-spinner id="panel-spinner" *ngIf="loader" class="centered"></mat-spinner>

          <div *ngIf="!hractivity">
            <mat-form-field class="custom-form-field">
              <mat-chip-grid #chipList>
                <mat-chip-row *ngFor="let emp of empList" [removable]="removable" (removed)="remove(emp)">
                  {{ emp.empName }}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip-row>
                <input
                  placeholder="{{ placeHold }}"
                  #empInput
                  [formControl]="empInputCtrl"
                  [(ngModel)]="hrEmpNo"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="add($event)"
                  [disabled]="loader"
                />
              </mat-chip-grid>
            </mat-form-field>
            <button class="primary-btn" (click)="validateId()" [disabled]="loader">Validate</button>
          </div>

          <mat-form-field class="custom-form-field">
            <input
              matInput
              placeholder="Remarks"
              name="coupledremarks"
              required
              [(ngModel)]="remarks"
              [disabled]="loader"
            />
          </mat-form-field>
          <mat-card appearance="outlined">
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="row nomarLR padTB16">
              <div class="col-4">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="saveBtn"
                  [disabled]="f1.invalid || disableSend"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
